import { FILE_MIME_TYPE_MAP } from 'shared/domains/filesystem';
export const getMimeType = (file) => {
    if (file.type) {
        return file.type;
    }
    const ext = file.name.slice(file.name.lastIndexOf('.'));
    return FILE_MIME_TYPE_MAP[ext];
};
